export class PostMessage {
    constructor() {}

    exec({ eventIdentifier, params }) {
        if (!eventIdentifier)
            throw Error(`Parâmetro eventIdentifier invàlido!`);

        return new Promise((resolve, reject) => {
            const handler = (e) => {
                if (e.origin.indexOf("file:") > -1) {
                    const rs = JSON.parse(e.data);

                    if (rs.status == 200) {
                        resolve(rs.data);
                    } else reject(Error(rs.message));
                    window.removeEventListener(eventIdentifier, handler);
                }
            };

            this._registerEventListener({
                eventIdentifier,
                eventHandler: handler
            });

            const paramsStringfy = JSON.stringify({
                params
            });

            window.parent.postMessage(paramsStringfy, "*");
        });
    }

    _registerEventListener({ eventIdentifier, eventHandler }) {
        if (window.addEventListener)
            window.addEventListener(eventIdentifier, eventHandler, false);
        else if (window.attachEvent)
            window.attachEvent("on" + eventIdentifier, eventHandler);
    }
}
